import React, { useEffect, useRef, useState } from 'react';
import Header from '../Header/Header';
import Working from '../Working/Working';
import WhyPsycare from '../WhyPsycare/WhyPsyCare';
import Facts from '../Facts/Facts';
import './LandingPage.css';
import Genie from "./genie.png";
import Intropage from '../Intropage/Intropage';

const LandingPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const wrapperRef = useRef();
  const pauseTimeoutRef = useRef(null);

  const slides = [<Intropage />, <Header />, <Facts />, <WhyPsycare />, <Working />];

  // Auto sliding interval
  useEffect(() => {
    if (isPaused) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => prev + 1);
    }, 11000);

    return () => clearInterval(interval);
  }, [isPaused]);

  // Reset slider to beginning
  useEffect(() => {
    if (currentSlide === slides.length) {
      const timeout = setTimeout(() => {
        wrapperRef.current.style.transition = 'none';
        wrapperRef.current.style.transform = 'translateX(0)';
        setCurrentSlide(0);
        setTimeout(() => {
          wrapperRef.current.style.transition = 'transform 1s ease-in-out';
        }, 50);
      }, 1000);
      return () => clearTimeout(timeout);
    }
  }, [currentSlide, slides.length]);

  // Handle click to pause/resume
  const handleUserInteraction = () => {
    setIsPaused(true);
    clearTimeout(pauseTimeoutRef.current);
    pauseTimeoutRef.current = setTimeout(() => {
      setIsPaused(false);
    }, 10000); // Resumes after 10 seconds
  };

  return (
    <div className="slider-container" onClick={handleUserInteraction}>
      <div
        className="slider-wrapper"
        ref={wrapperRef}
        style={{ transform: `translateX(-${currentSlide * 100}vw)` }}
      >
        {slides.map((Slide, i) => (
          <div className="slide" key={i}>
            {/* Only show genie on original slides, not the clone */}
            {currentSlide === i && currentSlide < slides.length && (
              <div className="genie-wrapper">
               <img src={Genie} alt="Genie" className="genie-img" />
                <div className="speech-bubble">
                  Click to hold for 10 secs
                </div>
              </div>
            )}
            {Slide}
          </div>
        ))}
        {/* Clone of first slide for seamless loop */}
        <div className="slide">{slides[0]}</div>
      </div>

      {/* Dot Indicators */}
      <div className="dots">
        {slides.map((_, i) => (
          <span
            key={i}
            className={`dot ${currentSlide % slides.length === i ? 'active' : ''}`}
            onClick={(e) => {
              e.stopPropagation(); // Prevent triggering parent click
              setCurrentSlide(i);
              setIsPaused(true);
              clearTimeout(pauseTimeoutRef.current);
              pauseTimeoutRef.current = setTimeout(() => setIsPaused(false), 10000);
            }}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default LandingPage;